import { Validators } from '@raskrask-dk/raskrask-utils'
import { ReactElement, useState } from 'react'
import CompanyNameFieldTemplate from '../../Fields/companyName'
import ContactNameFieldTemplate from '../../Fields/contactName'
import EmailFieldTemplate from '../../Fields/email'
import NameFieldTemplate from '../../Fields/name'
import PhoneFieldTemplate from '../../Fields/phone'
import { PropsCustomerFieldsTemplate } from './props'

const CustomerFieldsTemplate = ({
    companyNameHandler,
    contactNameHandler,
    emailHandler,
    nameHandler,
    phoneHandler,
    customerType,
    submitClickedWithMissingDetails,
}: PropsCustomerFieldsTemplate): ReactElement => {
    const [companyName, setCompanyName, canSetCompanyName] = companyNameHandler
    const [contactName, setContactName, canSetContactName] = contactNameHandler
    const [email, setEmail, canSetEmail] = emailHandler
    const [name, setName, canSetName] = nameHandler
    const [
        phone,
        setPhone,
        landCode,
        landCodes,
        onChangeLandCode,
        canSetPhone,
    ] = phoneHandler

    const [localCustomerPhone, setLocalCustomerPhone] = useState(
        phone?.toString().slice(2)
    )
    const changeCustomerPhone = (number: string) => {
        // the 'local' phone number should contain the "-" as this value is what is being displayed in the frontend
        setLocalCustomerPhone(number)
        // we want to 'clean' the phone number and remove the eventual "-".
        const cleanedPhoneNumber = number.replace('-', '')
        setPhone(parseInt(landCode.value + cleanedPhoneNumber))
    }

    const validCustomerPhone = Validators.phoneNumberValidator(
        parseInt(landCode.value + localCustomerPhone)
    )
    const validName = name !== '' && name !== undefined
    const validContactName = contactName !== '' && contactName !== undefined
    const validCompanyName = companyName !== '' && companyName !== undefined
    const validEmail = Validators.emailValidator(email!)

    return (
        <>
            {canSetName && (
                <NameFieldTemplate
                    validName={validName}
                    setName={setName}
                    name={name}
                    submitClickedWithMissingDetails={
                        submitClickedWithMissingDetails
                    }
                />
            )}
            {canSetCompanyName && (
                <CompanyNameFieldTemplate
                    companyName={companyName}
                    validCompanyName={validCompanyName}
                    setCompanyName={setCompanyName}
                    submitClickedWithMissingDetails={
                        submitClickedWithMissingDetails
                    }
                />
            )}
            {canSetContactName && (
                <ContactNameFieldTemplate
                    validContactName={validContactName}
                    setContactName={setContactName}
                    contactName={contactName}
                    submitClickedWithMissingDetails={
                        submitClickedWithMissingDetails
                    }
                />
            )}
            {canSetPhone && (
                <PhoneFieldTemplate
                    customerType={customerType}
                    landCodes={landCodes}
                    landCode={landCode}
                    validPhone={validCustomerPhone}
                    changePhone={changeCustomerPhone}
                    localPhone={localCustomerPhone}
                    onChangeLandCode={onChangeLandCode}
                    submitClickedWithMissingDetails={
                        submitClickedWithMissingDetails
                    }
                />
            )}
            {canSetEmail && (
                <EmailFieldTemplate
                    validEmail={validEmail}
                    setEmail={setEmail}
                    email={email}
                    submitClickedWithMissingDetails={
                        submitClickedWithMissingDetails
                    }
                />
            )}
        </>
    )
}

export default CustomerFieldsTemplate
